define(['jquery', 'common'], function ($, Common) {

	var ERVPostslist = function () {
		var self = this;
		self.$ervBody = $('#erv-body');
		self.common = new Common();

		// is to one because the page shows pageindex 0 first time it renders
		self.currentPageIndex = 0;
		self.rootPageId = 0;

		self.loadMorePosts = function ($button, e) {
			var newPageIndex = self.currentPageIndex + 1,
				url = '/' + self.postType + '/' + 'getnext' + self.postType + '?PageIndex=' + newPageIndex + '&PageId=' + self.rootPageId;
			
			if (self.$ervBody.find('[name^="SelectedCategories"]:checked').length > 0) {
				var selectedCategories = [];

				self.$ervBody.find('[name^="SelectedCategories"]:checked').each(function() {
					selectedCategories.push($(this).val());
				});

				url += '&selectedCategories=' + selectedCategories.toString();
			}

			if (self.$ervBody.find('#SelectedSorting').length > 0) {
				url += '&orderBy=' + self.$ervBody.find('#SelectedSorting').val();
			}
			
			self.common.forms.activateLoading($button, false, e);

			$.ajax({ type: 'GET', url: url,
				success: function (data) {
					self.currentPageIndex = newPageIndex;

					var $postlistContainer = self.$ervBody.find('#postslist-container');
					$postlistContainer.append(data);

					if (!self.hasMorePosts()) {
						self.$ervBody.find('#postslist-loadnext').remove();
					}

					self.common.initDataUrl($postlistContainer.find('[data-url]'));
					self.common.forms.deactivateLoading($button);

					self.common.initLazyLoad('#postslist-container .teaser-container:last');
				}
			});
		};

		self.hasMorePosts = function () {
			return self.currentPageIndex < self.totalPostsListPages - 1;
		};
	};

	ERVPostslist.prototype.init = function (postType) {
		var self = this;

		self.postType = postType;
		self.totalPostsListPages = self.$ervBody.find('#postslist-loadnext').data('totalposts');
		self.rootPageId = self.$ervBody.find('#postslist-loadnext').data('pageid');

		// wire up 'show more posts' button
		self.$ervBody.find('#postslist-loadnext').on('click', function (e) {
			e.preventDefault();
			self.loadMorePosts($(this), e);
		});

		self.$ervBody.find('[name^="SelectedCategories"]').on('change', function () {
			var $form = $(this).parents('form');
			self.common.forms.activateLoading($form, true);
		});

		self.$ervBody.find('#SelectedSorting').on('change', function () {
			var $form = $(this).parents('form');
			self.common.forms.activateLoading($form, true);
		});
	};

	return ERVPostslist;
});
